import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllConversationsByUserId = (candidateId, type, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETHING_ALL_CONVERSATIONS_BY_USER_ID' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/users/${candidateId}/conversation`,
            {
              params: {
                'request-id': reqId,
                recordType: type,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'FETHING_ALL_CONVERSATIONS_BY_USER_ID_DONE',
              payload: {
                conversations: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETHING_ALL_CONVERSATIONS_BY_USER_ID_FAILED',
              payload: `Failed to get conversations`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'FETHING_ALL_CONVERSATIONS_BY_USER_ID_FAILED',
            payload: `Failed to get conversations`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETHING_ALL_CONVERSATIONS_BY_USER_ID_FAILED',
        payload: `Failed to get conversations`,
      });
    }
  };
};

export default getAllConversationsByUserId;
